var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"grey lighten-5 fill-height",attrs:{"fluid":""}},[_c('v-layout',{attrs:{"column":""}},[_c('v-flex',[_c('CardsLine',{attrs:{"header":"Trash","data":_vm.trashed}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }